var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-screen',{staticClass:"startRegistration",attrs:{"title":_vm.$ml.get('infoSelectLoginTitle'),"text":_vm.$ml.get('infoSelectLoginText'),"action":_vm.nextScreen,"buttonText":_vm.$ml.get('infoSelectLoginButton'),"titleH1":false,"headerImg":4}})
}
var staticRenderFns = []

export { render, staticRenderFns }